import { Box, Skeleton } from '@rbilabs/universal-components';

import {
  ListItem,
  ProductSkeletonListContainer,
  ProductSkeletonListItems,
  SkeletonListItem,
} from './styled';

const SKELETON_ITEMS_COUNT = 3;

export const ProductSkeletonListItem = () => {
  return (
    <ProductSkeletonListContainer>
      <Skeleton width="1/3" h="$4" rounded="full" margin="$2" />
      <ProductSkeletonListItems>
        {Array.from({ length: SKELETON_ITEMS_COUNT }).map((_, index) => (
          <ListItem key={index}>
            <SkeletonListItem>
              <Box width="70px" height={'60px'}>
                <Skeleton flex={1} rounded="md" />
              </Box>
              <Box flex={1}>
                <Skeleton width="full" h="$4" rounded="full" margin="$2" />
                <Skeleton width="1/3" h="$4" rounded="full" margin="$2" />
              </Box>
            </SkeletonListItem>
          </ListItem>
        ))}
      </ProductSkeletonListItems>
    </ProductSkeletonListContainer>
  );
};
